import {Eye, MapIcon, Pen, Trash2} from "lucide-react";
import type Encounter from "@/encounter/model/Encounter.ts";
import {encounterCardImage} from "@/encounter/encounterCardImage.ts";
import {srcUrl} from "@/api/ImageApi.ts";
import {Button} from "@/components/ui/button.tsx";
import DeleteConfirm from "@/components/forms/DeleteConfirm.tsx";
import AuditMetadata from "@/components/management/AuditMetadata.tsx";

export default function EncounterDetail({encounter, displayed, onOpenMap, onEdit, onDisplay, onDelete}: {
    encounter: Encounter;
    displayed: boolean;
    onOpenMap: () => void;
    onEdit: () => void;
    onDisplay: () => Promise<unknown>;
    onDelete: () => Promise<void>;
}) {
    const image = encounterCardImage(encounter);
    return <article className="space-y-5">
        <title>{`${encounter.name} | DireDawn`}</title>
        <header className="overflow-hidden rounded-xl border border-border/80 bg-card/90 shadow-lg shadow-black/10 sm:flex">
            <div className="relative h-40 shrink-0 overflow-hidden bg-surface sm:w-64">
                {image && <img src={srcUrl(image)} alt="" className="size-full object-cover"/>}
                <div className="pointer-events-none absolute inset-0 bg-linear-to-t from-card/50 to-transparent"/>
            </div>
            <div className="min-w-0 flex-1 space-y-4 p-5 sm:p-6">
                <div className="flex flex-wrap items-start justify-between gap-4">
                    <div>
                        <p className="mb-2 text-xs font-semibold uppercase tracking-[0.22em] text-primary">Encounter verwalten</p>
                        <h1 className="text-3xl font-semibold tracking-tight">{encounter.name}</h1>
                        <p className="mt-1 text-sm text-muted-foreground">{encounter.dungeonName}</p>
                    </div>
                    <div className="flex flex-wrap items-center gap-2">
                        <Button variant="outline" onClick={onOpenMap}><MapIcon/>Karte</Button>
                        <Button variant="outline" onClick={() => void onDisplay()}><Eye/>Spielern anzeigen</Button>
                        <Button variant="outline" onClick={onEdit}><Pen/>Bearbeiten</Button>
                        <DeleteConfirm title={`${encounter.name} löschen?`} onConfirm={onDelete}>
                            <Button variant="destructive" onSelect={event => event.preventDefault()}><Trash2/>Löschen</Button>
                        </DeleteConfirm>
                    </div>
                </div>
                <AuditMetadata createdAt={encounter.createdAt} updatedAt={encounter.updatedAt}/>
            </div>
        </header>
        <section className="rounded-xl border border-border/80 bg-card/90 p-5">
            <h2 className="text-lg font-semibold">Dungeon</h2>
            <p className="mt-1 text-muted-foreground">{encounter.dungeonName}</p>
            {displayed && <p className="mt-3 text-sm text-primary">Wird den Spielern angezeigt</p>}
        </section>
    </article>;
}
